/**
 * Renders MUI input labels as a static block ABOVE the field instead of the
 * default floating label that sits on the outline. Our form inputs use a
 * custom border (notchedOutline border removed), which breaks MUI's notch and
 * makes the floating label overlap the border line. Placing the label above
 * the input avoids that entirely.
 *
 * Works both when spread into a field's own `sx` and when applied to a
 * container `<Box>` — the descendant selectors match either way.
 */
export const labelAboveSx = {
  '& .MuiInputLabel-root': {
    position: 'static !important',
    transform: 'none !important',
    pointerEvents: 'auto',
    maxWidth: '100%',
    whiteSpace: 'normal',
    marginBottom: '3px',
    lineHeight: 1.2,
    fontSize: 'var(--text-sm)',
    fontWeight: 500,
    color: 'var(--color-text-secondary)',
  },
  // Keep the reserved helper-text line tight so labels-above don't inflate
  // each field's overall height too much.
  '& .MuiFormHelperText-root': {
    marginTop: '3px',
    lineHeight: 1.2,
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'var(--color-text-secondary)',
  },
  '& .MuiInputLabel-root.Mui-error': {
    color: 'var(--color-error)',
  },
  '& .MuiInputLabel-asterisk': {
    color: 'var(--color-error)',
  },
  // With the label above the field, the notch gap in the top border is no
  // longer needed — hide the legend so the border stays unbroken.
  '& .MuiOutlinedInput-notchedOutline legend': {
    display: 'none',
  },
  // MUI insets the outline by -5px at the top to make room for the floating
  // label sitting on the border. Since our label is above the field, that
  // offset just makes the outline box 5px taller than the input, leaving a
  // stray band above the content. Pin it flush so the border matches the
  // real input size.
  '& .MuiOutlinedInput-notchedOutline': {
    top: 0,
  },
};
